import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { localizeDate as _localizeDate, userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'SettingsAnnouncementTable',
  mixins: [userItemsPerListMixin],
  props: {
    maintenance: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    },
    searchTerm: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      key: 'systemAnnouncements',
      deletePrompt: false,
      deleteAnnouncement: null,
      expandedItems: [],
      announcements: [],
      search: '',
      tableOptions: _objectSpread({}, defaultTableOptions),
      disableFetchOnCreatedMixin: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('Common.active'),
          value: 'active'
        }, {
          sortable: false,
          text: this.$i18n_t('accMgmt.announcement.announcement'),
          value: 'message'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.announcement.start'),
          value: 'start'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.announcement.end'),
          value: 'end'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    maintenance: function maintenance(list) {
      this.announcements = list;
    },
    searchTerm: function searchTerm(term) {
      this.search = term;
    }
  },
  mounted: function mounted() {
    this.announcements = this.maintenance;
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  methods: {
    clickedAnnouncementTableRow: function clickedAnnouncementTableRow(item) {
      if (this.expandedItems.length === 0 || this.expandedItems[0].id !== item.id) {
        this.expandedItems = [item];
      } else {
        this.expandedItems = [];
      }
    },
    editAnnouncement: function editAnnouncement(announcement) {
      this.$emit('openEditDialog', announcement);
    },
    doDeleteAnnouncement: function doDeleteAnnouncement(announcement) {
      this.$emit('deleteAnnouncement', announcement);
    },
    localizeDate: function localizeDate(item) {
      if (item) {
        return _localizeDate(item);
      }
    },
    updatePagination: function updatePagination(e) {
      if (e.page === parseInt(this.$route.query.page, 10) && e.itemsPerPage === parseInt(this.$route.query.perPage, 10)) {
        // If page or itemsPerPage didn't change, don't update the URL
        return;
      }

      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};